var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal-main"},[(_vm.isLoading)?_c('van-loading',{staticClass:"loading",attrs:{"color":"#0055DC"}}):_vm._e(),(_vm.isLoaded)?[(_vm.$utils.isPhone())?_c('sub-h5-personal'):_c('sub-pc-personal')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }